import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { TreeItemWithIcon } from 'components/treeselect/CustomTreeItem';

function UncheckedIcon() {
  return <span className="block h-5 w-5 rounded border border-[#1a1a1a]" />;
}

function CheckedIcon() {
  return (
    <span className="flex h-5 w-5 items-center justify-center rounded border border-[#1a1a1a] bg-[#1a1a1a]">
      <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" aria-hidden="true">
        <path d="M15.938 6.25l-7.5 7.5L4.688 10" fill="none" stroke="white" strokeWidth="1.5" />
      </svg>
    </span>
  );
}

function IndeterminateIcon() {
  return (
    <span className="flex h-5 w-5 items-center justify-center rounded border border-[#1a1a1a] bg-[#1a1a1a]">
      <svg viewBox="0 0 20 20" className="h-[18px] w-[18px]" aria-hidden="true">
        <path d="M5 10h10" fill="none" stroke="white" strokeWidth="2" />
      </svg>
    </span>
  );
}

export const CustomCheckbox = React.memo(
  React.forwardRef<
    HTMLInputElement,
    React.InputHTMLAttributes<HTMLInputElement> & {
      checked: boolean;
      onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
      item: TreeItemWithIcon;
    }
  >((props, ref) => {
    const indeterminateAwareOnChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (props.item.indeterminate) {
        // We forced an unchecked to checked to display the indeterminate value
        // Mui-x is ignoring the checked value we passing in and using the value from the event target
        // This will set that value to true to have the tree see there was a change and call onItemSelectionToggle
        props.onChange({ ...event, target: { ...event.target, checked: true } }, true);
      } else {
        props.onChange(event, checked);
      }
    };

    return (
      <Checkbox
        inputRef={ref}
        checked={props.checked || props.item.indeterminate}
        indeterminate={!!props.item.indeterminate}
        disabled={props.disabled}
        onChange={indeterminateAwareOnChange}
        icon={<UncheckedIcon />}
        checkedIcon={<CheckedIcon />}
        indeterminateIcon={<IndeterminateIcon />}
        sx={{
          width: 20,
          height: 20,
          padding: 0,
          margin: '2px 4px 2px 2px',
          color: '#1a1a1a',
        }}
      />
    );
  })
);
